import { AlertTriangle, CheckCircle2, Info, XCircle, Lightbulb } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";

const VARIANTS = {
  success: {
    icon: CheckCircle2,
    card: "border-emerald-200 bg-emerald-50 text-emerald-900",
    iconClass: "text-primary",
  },

  warning: {
    icon: AlertTriangle,
    card: "border-amber-200 bg-amber-50 text-amber-900",
    iconClass: "text-primary",
  },

  info: {
    icon: Info,
    card: "border-sky-200 bg-sky-50 text-sky-900",
    iconClass: "text-primary",
  },

  destructive: {
    icon: XCircle,
    card: "border-red-200 bg-red-50 text-red-900",
    iconClass: "text-primary",
  },

  default: {
    icon: Lightbulb,
    card: "border-border bg-card text-foreground",
    iconClass: "text-primary",
  },
};

export default function InsightCard({
  type = "info",
  title,
  children,
}) {
  const variant = VARIANTS[type] ?? VARIANTS.info;
  const Icon = variant.icon;

  return (
    <Card className={variant.card}>
      <CardContent className="flex gap-4 p-5 text-inherit">
        <Icon
          className={`mt-0.5 h-5 w-5 shrink-0 ${variant.iconClass}`}
        />

        <div className="space-y-1 text-inherit">
          <h4 className="font-semibold text-inherit">
            {title}
          </h4>

          <div className="text-sm leading-6 text-inherit opacity-95">
            {children}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}